export default {
  checkout: {
    // Fields

    /*********************************************************************************************
     * User configurable messages
     * TODO: Populate from API
     */
    privacyButton: ' Datenschutzrichtlinie',
    privacyPolicyRequiredMessage: 'Sie müssen die Datenschutzrichtlinie akzeptieren, um fortzufahren.',
    shareRating: 'Sie haben {0} bewertet',
    shareComment: "Sie haben gesagt: '{n}'",
    shareStaffApplaud: 'Sie haben {n} gelobt',
    shareSocialSubject: 'Ich empfehle diesen Ort!',
    shareSocialMsg: 'Ich war gerade bei {n}. Das habe ich gedacht: #feeditback',
    share: {
      title: 'Vielen Dank, dass Sie 125 Data & Insights nutzen',
      link: {
        facebook: 'Auf Facebook teilen',
        twitter: 'Teilen auf X',
        email: 'Per E-Mail teilen'
      },
      tip: {
        label: 'Hinterlassen Sie einen Tipp'
      }
    },
    recommend: {
      skip: 'Überspringen',
      suggestions: {
        title: 'KI generierte vorgeschlagenes Feedback',
        description: 'Bitte teilen Sie Ihre Erfahrungen',
        copy: 'In die Zwischenablage kopieren',
        copied: 'Kopiert',
        copiedToClipboard: 'In die Zwischenablage kopiert',
        error: 'Es gibt nicht genügend Informationen, um eine fundierte Antwort zu geben',
        generate: 'Generieren Sie KI-Text'
      }
    },
    email: 'E-Mail',
    emailAlt: 'Teilen Sie dies per E-Mail',
    //dynamic use
    facebookAlt: 'Teilen Sie dies über Facebook',
    //dynamic use
    googleAlt: 'Eine Bewertung auf Google verfassen',
    //dynamic use
    thankYouHeader: 'Danke',
    thankYouPermission: 'Vielen Dank!',
    thankYouVoucher: 'Vielen Dank für Ihre Zeit! Wir hoffen, Sie genießen den Gutschein.',
    voucherScratchText: "Rubbeln Sie hier, um Ihren Gutschein einzul\xF6sen!",
    weAreSorryHeader: 'Es tut uns leid',
    weAreSorryText: 'Es tut uns leid text',
    uploadFileSizeError: 'Ihre Datei muss kleiner als {n} sein',
    uploadError: 'Unbekannter Fehler',
    uploadDelete: 'Foto löschen',
    recaptchaCheckbox: 'Ich bin kein Roboter'
  }
};